import { useState, useEffect, useContext } from 'react';
import styles from './OnboardingChecklist.module.css'
import { IconAngleLeftBold, IconAngleRightBold, IconCheckmarkCircle } from '../../assets/icons';
import { UserContext } from '../../contexts/user-context';

const onboardingEventTypes = {
    EMAIL_VERIFIED: 'emailVerified',
    ACCOUNT_ADDED: 'accountAdded',
    TRANSACTION_CREATED: 'transactionCreated'
}

const checklistItems = [
    {
        lookupKey: onboardingEventTypes.EMAIL_VERIFIED,
        displayTitle: "Verify Email",
        description: "We sent an email when you signed up. Click the link provided and you're all set.",
        completed: false
    },
    {
        lookupKey: onboardingEventTypes.ACCOUNT_ADDED,
        displayTitle: "Connect Your Accounts",
        description: "Securely connect your bank accounts to get a full picture of your finances.",
        completed: false
    },
    {
        lookupKey: onboardingEventTypes.TRANSACTION_CREATED,
        displayTitle: "Add Transactions to Your Budget",
        description: "Don't worry if you miss a few - we'll help you fill in the gaps.",
        completed: false
    },
];

const OnboardingChecklist = () => {
    const [onboardingChecklist, setOnboardingChecklist] = useState(null);
    const [onboardingEventsCompleted, setOnboardingEventsCompleted] = useState(false);
    const [visible, setVisible] = useState(false);
    const { ddUser, ddUserEvents } = useContext(UserContext);

    const handleToggle = () => {
        setVisible(!visible);
    };

    const checkForCompletion = (events) => {
        if (!events) return false;

        return checklistItems.map(item => {
            const event = events.find(event => event.lookup_key === item.lookupKey);
            item.completed = !!event;
            return item;
        }).every(item => item.completed);
    }

    useEffect(() => {
        if (!ddUser || !ddUserEvents) return;

        const completed = checkForCompletion(ddUserEvents);

        if (completed) {
            setOnboardingEventsCompleted(true);
            return;
        };

        setOnboardingEventsCompleted(false);
        setOnboardingChecklist(checklistItems);

    }, [ddUser, ddUserEvents, onboardingEventsCompleted, onboardingChecklist]);
    
    return !onboardingEventsCompleted && onboardingChecklist ? (
        <div className={`${styles.onboardingChecklist} ${visible ? styles.visible : ''}`}>

            <div className={styles.onboardingChecklistBody}>
                <h2>Onboarding Checklist</h2>

                <ul className={styles.items}>
                    {onboardingChecklist.map((item) => (
                        <li key={item.lookupKey} className={`${styles.item} ${item.completed ? styles.completed : ''}`}>
                            <div className={styles.itemIconWrap}>
                                <IconCheckmarkCircle fill={item.completed ? "#10b981" : "#fff"} style={{
                                    fill: item.completed ? "#10b981" : "#fff"
                                }} />
                            </div>
                            <div className={styles.itemCopyWrap}>
                                <h3 className={styles.itemTitle}>{item.displayTitle}</h3>
                                <p className={styles.itemDescription}>{item.description}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <button
                className={`${styles.onboardingChecklistBtnToggle} button-unstyled`}
                onClick={handleToggle}
            >
                {visible ? <IconAngleLeftBold fill="#fff" /> : <IconAngleRightBold fill="#fff" />}
            </button>
        </div>
    ) : null;
};

export default OnboardingChecklist;